import { render } from "./FloatingMenu.vue?vue&type=template&id=90e9f9a6"
import script from "./FloatingMenu.vue?vue&type=script&lang=js"
export * from "./FloatingMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__